import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

type StyleProps = {
  fixedHeight: boolean
}

const contentStyles = () => css`
  label: content;

  overflow-y: auto;
`

const fixedHeightContentStyles = ({ fixedHeight, theme }: Theme & StyleProps) =>
  fixedHeight &&
  css`
    label: content--fixed-height;

    ${theme.media.giga} {
      max-height: 128px;
    }
  `

export const Content = styled('div')(contentStyles, fixedHeightContentStyles)
